import React from 'react';
import styles from './ItemCard.module.css';

interface TimeSlotProps {
  time: string;
}

const TimeSlot: React.FC<TimeSlotProps> = ({ time }) => {
  return <div className={styles.timeSlot}>{time}</div>;
};

export default TimeSlot;
